<template>
  <div>
    <!-- search input -->
    <section id="kb-category-search">
      <b-card
          :style="{
          backgroundImage: `url(${require('@/assets/images/banner/banner.png')})`,
        }"
          class="knowledge-base-bg text-center"
          no-body
      >
        <b-card-body class="card-body">
          <h2 class="text-primary">{{ this.$route.params.categoryName }}</h2>
          <b-card-text class="mb-2">
            <span>Tìm kiếm nổi bật: </span>
            <span class="font-weight-bolder"
            >Sales automation, Email marketing</span
            >
          </b-card-text>

          <!-- form -->
          <b-form class="kb-search-input">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon"/>
              </b-input-group-prepend>
              <b-form-input
                  id="searchbar"
                  v-model="knowledgeBaseSearchQuery"
                  placeholder="Tìm chỉ đề...."
              />
            </b-input-group>
          </b-form>
          <!-- form -->
        </b-card-body>
      </b-card>
    </section>
    <!--/ search input -->

    <div id="knowledge-base-category">
      <b-row class="match-height">
        <b-col v-for="(data, index) in filteredKB" :key="index" md="4" sm="6">
          <b-card>
            <h6 class="kb-title">
              <feather-icon
                  class="mr-50 text-success"
                  icon="SettingsIcon"
                  size="20"
              />
              {{ data.Name }}
            </h6>
            <b-list-group class="list-group-circle mt-2">
              <b-list-group-item
                  v-for="que in news.filter((item) => item.CategoryID == data.ID)"
                  :key="que.ID"
                  :to="{
                  path: `/news/category/topics/${que.ID}`,
                }"
                  class="text-body"
              >
                {{ que.Title }}
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-col>

        <!-- no result found -->
        <b-col v-show="!filteredKB.length" class="text-center" cols="12">
          <h4 class="mt-4">Search result not found!!</h4>
        </b-col>
        <!--/ no result found -->
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardText,
  BCol,
  BForm,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BListGroup,
  BListGroupItem,
  BRow,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BListGroup,
    BListGroupItem,
    BCardBody,
    BCardText,
    BForm,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
  },
  data() {
    return {
      knowledgeBaseSearchQuery: "",
      kb: [],
      categoriesID: this.$route.params.categoryId,
      news: [],
    };
  },
  computed: {
    filteredKB() {
      const knowledgeBaseSearchQueryLower =
          this.knowledgeBaseSearchQuery.toLowerCase();
      return this.kb.filter(
          (item) =>
              item.Name.toLowerCase().includes(knowledgeBaseSearchQueryLower) ||
              item.Name.filter((queObj) =>
                  queObj.question
                      .toLowerCase()
                      .includes(knowledgeBaseSearchQueryLower)
              ).length
      );
    },
  },

  created() {
    this.fetchData();
    this.fetchNews();
  },
  methods: {
    fetchData() {
      useJwt
          .get("/news/categories")
          .then((response) => {
            if (response.data.code == 200) {
              this.kb = response.data.result.filter(
                  (item) => item.ParentID == this.categoriesID
              );
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Lấy thông tin thành công",
                  icon: "AlertTriangleIcon",
                  variant: "success",
                },
              });
            }
          })
          .catch((err) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.result,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },

    fetchNews() {
      useJwt
          .post("/news/search", {
            columnFilters: {
              //  "CategoryID": 1
            },
          })
          .then((response) => {
            if (response.data.code == 200) {
              this.news = response.data.result;
            }
          })
          .catch((err) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.result,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-knowledge-base.scss";
</style>
